import Vector from "../logic/Vector"

const mouse = {
	position: new Vector(0, 0)
}

export default mouse